export default __webpack_public_path__ + "static/about-us-2-7a963f5a48820beee00d99749cc1fe36.png";